import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../utils/i18n';
import iconBlock from '@adsk/bim360-matrix-react-assets/icon-block.svg';
import iconCheck from '@adsk/bim360-matrix-react-assets/icon-check.svg';
import IssueTypesAdminStatus from './IssueTypesAdminStatus';
import {ISSUE_TYPES_STATUS_TYPES} from '../../../constants/issue-types';
import SelectBoxAdapter from '../../common/SelectBoxAdapter';

export default class IssueTypeStatusDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.issueTypeStatuses = [
      IssueTypeStatusDropdown.IssueTypeStatuses.ACTIVE,
      IssueTypeStatusDropdown.IssueTypeStatuses.INACTIVE
    ];
  }

  _dropdownItemRenderer(val) {
    const isActive = val === ISSUE_TYPES_STATUS_TYPES.ACTIVE;
    return <IssueTypesAdminStatus isActive={isActive} />;
  }

  render() {
    return (
      <SelectBoxAdapter
        className="IssueTypeStatusDropdown"
        options={this.issueTypeStatuses}
        onChange={this.props.onChange}
        selectedOptions={this.props.selected}
        optionRenderer={this._dropdownItemRenderer}
        valueRenderer={this._dropdownItemRenderer}
        disabled={this.props.disabled}
      />
    );
  }
}

IssueTypeStatusDropdown.displayName = 'IssueTypeStatusDropdown';

IssueTypeStatusDropdown.IssueTypeStatuses = {
  ACTIVE: {
    label: i18n.t('issueTypes.statuses.active'),
    value: ISSUE_TYPES_STATUS_TYPES.ACTIVE,
    icon: iconCheck
  },
  INACTIVE: {
    label: i18n.t('issueTypes.statuses.inactive'),
    value: ISSUE_TYPES_STATUS_TYPES.INACTIVE,
    icon: iconBlock
  }
};

IssueTypeStatusDropdown.defaultProps = {
  selected: IssueTypeStatusDropdown.IssueTypeStatuses.ACTIVE
};

IssueTypeStatusDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.object,
  disabled: PropTypes.bool
};
